module.exports = __webpack_public_path__ + "img/footer-img2.570ce6c7.jpg";